import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {RouterModule} from '@angular/router';
import {EvidenceListComponent} from './evidence-list.component';
import {MADirectivesModule} from 'src/app/directives/ma-directives.module';

@NgModule({
  declarations: [EvidenceListComponent],
  imports: [CommonModule, IonicModule, RouterModule, MADirectivesModule],
  exports: [EvidenceListComponent],
})
export class EvidenceListModule {}
